const ADMIN_ACTIONS = {
  LOGIN: 'ADMIN::LOGIN',
  LOGIN_ERROR: 'ADMIN::LOGIN_ERROR',
  FORGOT:'ADMIN::FORGOT'
};
export default ADMIN_ACTIONS
